<div class="dialog-title">{{type}} Sales Document</div>

<form [formGroup]="uploadSalesDocForm">
  <mat-form-field>
    <input
      formControlName="docName"
      matInput
      placeholder="Document Name"
      required
    />
    <mat-error>Sales Document Name is required</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Type</mat-label>
    <mat-select formControlName="type" required>
      <mat-option
        *ngFor="let type of salesDocType | keyvalue"
        [value]="type.key"
        >{{type.value}}</mat-option
      >
    </mat-select>
    <mat-error>Sales Document Type is required</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      type="text"
      matInput
      placeholder="Upload File"
      readonly
      formControlName="file"
      (click)="fileInput.click()"
      required
    />
    <div matSuffix (click)="fileInput.click()">
      <mat-icon>publish</mat-icon>
    </div>
    <input
      type="file"
      name="pic"
      [accept]="acceptFileType.join()"
      (change)="fileChange($event)"
      style="display: none"
      #fileInput
    />
    <mat-error>Sales Document File is required</mat-error>
  </mat-form-field>
  <section>
    <mat-checkbox formControlName="allowSalesTeam"
      >Allow Sales Team Access</mat-checkbox
    >
  </section>

  <section>
    <mat-checkbox formControlName="allowAgency"
      >Allow Appointed Sales Agency Access</mat-checkbox
    >
  </section>

  <div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">
      Cancel
    </button>
    <button mat-button color="primary" (click)="submit()">{{type}}</button>
  </div>
</form>